// extracted by mini-css-extract-plugin
export default {"logoBox":"Logo_logoBox__L1JYz","pointerBox":"Logo_pointerBox__KFD87"};